const data = [
  {
    link: "/",
    title: "Homepage",
    searchslug: "home homepage index",
    description:
      "Eclipse International is a leading american mattress brand in India who manufacturers the best quality mattresses and bed accessories that gives the best sleeping experience",
  },
  {
    link: "/about/",
    title: "About",
    searchslug: "about legacy",
    description:
      "Eclipse International is a leading American luxury Mattress brand that gives you a world-class sleep since 1905. Check out our ranges of Mattress and bed accessories.",
  },
  {
    link: "/patented-technology/",
    title: "Patented Technology",
    searchslug: "patentedtechnolgy",
    description:
      "Explore the patented technologies with proven results that power the Eclipse range of exclusive and innovative handcrafted mattresses.",
  },

  {
    link: "/patent-series-mattress/",
    title: "Patent Series",
    searchslug: "patent series mattress",
    description:
      "Years of R&D have culminated in a signature series of exclusive mattresses with advanced technologies and the finest materials.",
  },
  {
    link: "/patent-series-mattress/coil-on-coil/",
    title: "Coil On Coil",
    searchslug: "Coil on Coil patent series mattress",
    description:
      "Buy the most advanced and superlative coil on Coil Spring Mattress at Best Price with 10 years warranty. Combined with pocket spring and Bonnell inner springs",
  },

  {
    link: "/patent-series-mattress/tiara-cool/",
    title: "Tiara Cool",
    searchslug: "Tiara Cool patent series mattress",
    description:
      "Buy Tiara Cool gel foam mattress with 10 years warranty that is designed for a thermally neutral and comfortable sleep, with memory foam and cool gel on one side and natural latex on the other.",
  },
  {
    link: "/patent-series-mattress/accolade-pt/",
    title: "Accolade PT",
    searchslug: "accolade pt patent series mattress",
    description: `Buy Accolade Pocket spring mattress in 8" & 10" sizes with 10 years warranty that gives you sound rest and relaxation to your body and sleep like a winner. Recommended by chiropractors`,
  },
  {
    link: "/patent-series-mattress/romance/",
    title: "Romance",
    searchslug: "Romance patent series mattress",
    description: `Buy Romance memory foam mattress from Eclipse International in 6", 8" & 10" sizes with 10 years warranty which uses a unique blend of Natural Latex, Memory Foam, and High Resilience Foam to provide multiple comfort levels to couples`,
  },
  {
    link: "/patent-series-mattress/healthsense-et/",
    title: "Healthsense ET",
    searchslug: "Healthsense ET patent series mattress",
    description:
      "Buy Pocket spring mattress with 10 years warranty designed with Spinal Zone and Life Edge technologies gives you comfortable and carefree sleep.",
  },
  {
    link: "/patent-series-mattress/vienna-et/",
    title: "Vienna ET",
    searchslug: "Vienna ET patent series mattress",
    description:
      "Buy Vienna natural latex mattress with 10 years warranty designed with spinal zone patented technology considering ideal for back and neck issues for a comfortable sleep.",
  },
  {
    link: "/luxury-collection/",
    title: "Luxury Collection",
    searchslug: "Luxury Collection series",
    description:
      "Eclipse International has designed luxury mattresses that provides high back support with unique benefits. Made with plush fabric and premium border designs, the collection is heaven for a sleeperâ€™s body. Check out the wide range of collection",
  },
  {
    link: "/harmony-collection/harmony-edge/",
    title: "Harmony Edge",
    searchslug: "Harmony Edge Luxury Collection",
    description:
      "Harmony Edge Mattress is designed with 100% latex top and Tencel fabric for optimum comfort and next to none carbon footprints",
  },
  {
    link: "/harmony-collection/outlast/",
    title: "Outlast",
    searchslug: "Outlast Luxury Collection",
    description:
      "Buy Eclipse outlast memory foam mattress with 5 years warranty that is free of odors, environmental friendly and breathable that is luxurious High Resilience Foam at base",
  },
  {
    link: "/luxury-collection/ortho-visco-lx/",
    title: "Ortho Visco LX",
    searchslug: "Ortho Visco LX Luxury Collection",
    description:
      "Buy Ortho Visco LX which is a memory foam mattress that eliminates the problem of heating in tropical conditions. Free of odors, environmental friendly and breathable.",
  },
  {
    link: "/luxury-collection/ortho-latex-lx/",
    title: "Ortho Latex LX",
    searchslug: "Ortho Latex LX Luxury Collection",
    description:
      "Buy Ortho latex mattress that is designed with 100% latex of Orthobond foam as Core to provide firm support to the sleeper's body. Free of odors, environmentally safe and breathable",
  },
  {
    link: "/serene-series/ortho-care-lx/",
    title: "Ortho Care LX",
    searchslug: "Ortho Care LX Luxury Collection",
    description:
      "Ortho care mattress provides plush comfort to every sleeper, perfect combination of rebonded foam, custom made Eclipse high-density foam and Euro-top. Extends lower back support at an economical price. Economically priced to fit your budget.",
  },
  {
    link: "/harmony-collection/harmony-ortho/",
    title: "Harmony Ortho",
    searchslug: "Harmony Ortho Luxury Collection",
    description:
      "Eclipse Harmony ortho mattress is a dual comfort mattress which is perfect companion for old-age people who require high back support and top-notch comfort",
  },
  {
    link: "/visco-mattress/",
    title: "Visco Mattress",
    searchslug: "Visco Mattress",
    description:
      "Buy Best Memory Foam Mattress from Eclipse International adjust to the sleeper's body heat for added comfort, and relieve pain, body aches and soreness, making it the ideal choice for preventing and alleviating chronic spinal conditions and improving sleep posture",
  },
  {
    link: "/luxury-collection/posture-comfort/",
    title: "Posture Comfort",
    searchslug: "Posture Comfort Visco Mattress",
    description:
      "Buy posture comfort memory foam mattress with 10 years warranty from Eclipse International bringing finest quality pocketed springs and pressure relieving. Good for people who have long sitting hours at work",
  },
  {
    link: "/luxury-collection/posture-care/",
    title: "Posture Care",
    searchslug: "Posture Care Visco Mattress",
    description:
      "Pressure relieving and temperature sensitive memory foam mattress with 10 years warranty from Eclipse International. ",
  },
  {
    link: "/luxury-collection/posture-therapy/",
    title: "Posture Therapy",
    searchslug: "Posture Therapy Visco Mattress",
    description:
      "Shop Posture Therapy memory foam mattress from Eclipse International made of finest quality bamboo fabric for smooth and cooling comfort.",
  },
  {
    link: "/visco-mattress/ortho-visco/",
    title: "Ortho Visco",
    searchslug: "Ortho Visco Visco Mattress",
    description: `Buy Ortho Visco memory foam mattress from Eclipse Mattress that comes in 5", 6", ET", & 8", ET" sizes designed with a combination of high-density Visco Elastic Memory foam and high-density Orthobond foam as a core for body contouring support`,
  },
  {
    link: " /conformatic-mattress/",
    title: "Conformatic Mattress",
    searchslug: "Conformatic Mattress",
    description:
      "Comformatic Pocket Spring mattress from Eclipse Mattress which not only relieves various pressure points across your body but also gives zero partner disturbance",
  },
  {
    link: "/conformatic-mattress/portofino-pt/",
    title: "Portofino PT",
    searchslug: "Portofino PT Conformatic Mattress",
    description:
      "Buy Eclipse Portofino PT Pocket spring mattress with 10 years warrantyat 6″ PT & 8″ PT sizes that gives a great sleep experience in a Pillow top construction.",
  },
  {
    link: "/serene-series/portofino/",
    title: "Portofino",
    searchslug: "Portofino Conformatic Mattress",
    description:
      "Buy Portofino Pocket Spring mattress from Eclipse Mattress with 10 years warranty in 6″, 8″ & 10″ sizes that are designed to deliver optimum support and comfort",
  },
  {
    link: "/ortho-mattress/",
    title: "Ortho Mattress Series",
    searchslug: "Ortho Mattress",
    description:
      "Buy ortho series of orthopedic mattresses in India at the best prices. Explore the various series of ortho mattress as per your need and comfort from India's best mattress manufacturer.",
  },
  {
    link: "/ortho-mattress/ortho-care-et/",
    title: "Ortho Care ET",
    searchslug: "Ortho Care ET Ortho Mattress",
    description:
      "Buy the best ortho mattress in India made up of high-density plush ultra foam which gives you high back support with 5 years warranty.",
  },
  {
    link: "/ortho-mattress/ortho-care/",
    title: "Ortho Care",
    searchslug: "Ortho Care Ortho Mattress",
    description:
      "Buy the ortho care Orthopedic mattress made with the combination of rebonded foam and high-density softy plush foam gives you comfort and spine support.",
  },
  {
    link: "/ortho-mattress/orthospine/",
    title: "Orthospine",
    searchslug: "Orthospine Ortho Mattress",
    description:
      "Buy the orthospine orthopedic mattress made up with high-density ultra-plush foam which provides lower back support with 5 years warranty",
  },
  {
    link: "/ortho-mattress/orthotonic/",
    title: "Orthotonic",
    searchslug: "Orthotonic Ortho Mattress",
    description:
      "Orthopedic mattress made with American lumbar support technology-  get great sleep with back pain relief.",
  },
  {
    link: "/latex-mattress/",
    title: "Latex Mattress",
    searchslug: "Latex Mattress",
    description:
      "Buy best quality natural latex mattress for back pain with upto 10 years warranty in 6 relaxing body's pressure points and guaranteeing a restful sleep.",
  },
  {
    link: "/latex-mattress/natura-latex/",
    title: "Natura Latex",
    searchslug: "Natura Latex Latex Mattress",
    description:
      "Pressure relief and body contouring with the finest natural Talalay latex. Learn more about Eclipse's Natural Latex matress with a 10 year warranty. ",
  },

  {
    link: "/latex-mattress/portofino-latex/",
    title: "Portofino Latex",
    searchslug: "Portofino Latex Latex Mattress",
    description:
      "Shop premium quality of latex mattress from Eclipse International with the finest quality individual Pocketed springs as core coupled with durable 100% Latex on top",
  },
  {
    link: "/latex-mattress/princeton-latex/",
    title: "Princeton Latex",
    searchslug: "Princeton Latex Latex Mattress",
    description:
      "Shop best quality premium latex mattress with 10 years warranty from Eclipse Mattress. Our expert team designed to provide an elite sleeping experience",
  },
  {
    link: "/latex-mattress/ortho-latex/",
    title: "Ortho Latex",
    searchslug: "Ortho Latex Latex Mattress",
    description:
      "Shop Ortho latex mattress from Eclipse mattress with 5 years warranty made with 100% latex providing firm high back support to the body",
  },
  {
    link: "/contour-series/",
    title: "Contour Care Series",
    searchslug: "Contour Care Series",
    description:
      "Buy the best spring mattress at best prices from contour collection that gives you support and various levels of comfort. Available in different sizes for single bed mattress and double bed mattress",
  },
  {
    link: "/contour-series/princeton-pt/",
    title: "Princeton PT",
    searchslug: "Princeton PT Contour Care Series",
    description:
      "Buy Princeton PT Bonnell spring mattress from Eclipse International made with chiropedic coil providing the high back support of medium firmness",
  },
  {
    link: "/serene-series/princeton/",
    title: "Princeton",
    searchslug: "Princeton Contour Care Series",
    description:
      "Buy Princeton Bonnell Spring mattress with 10 years warranty from eclipse mattress designed with premium quality HD fillings providing back support",
  },
  {
    link: "/hospitality/",
    title: "Hospitality Series",
    searchslug: "Hospitality Series",
    description:
      "Luxurious bedding solutions and handcrafted mattresses used by the world’s leading hotel brands. Download the Eclipse Hospitality Catalog today. ",
  },
  {
    link: "/hospitality/chiro-elite/",
    title: "Chiro Elite",
    searchslug: "Chiro Elite Hospitality Series",
    description:
      "Royal upholstery, HD Pocketed Springs and Visco Memory Foam for the best comfort possible in the hospitality industry.",
  },
  {
    link: "/hospitality/chiro-charge/",
    title: "Chiro Charge",
    searchslug: "Chiro charge Hospitality Series",
    description:
      "Designed for the best hotel brands in the world with high tensile pocketed springs and Eurotop construction for premium comfort.",
  },
  {
    link: "/hospitality/chiro-charge-pt/",
    title: "Chiro Charge PT",
    searchslug: "Chiro charge PT Hospitality Series",
    description:
      "Avant garde mattress with pocketed springs, finest upholstery and ergonomic sleeping experience for unmatched aesthetic value and comfort in the hospitality industry.",
  },
  {
    link: "/hospitality/chiro-coil/",
    title: "Chiro Coil",
    searchslug: "Chiro Coil Hospitality Series",
    description:
      "Pioneer mattress in the hotel industry- combining Bonnell Spings with HR foam and premium FR fabric with high durability for hospitality usage.",
  },
  {
    link: "/kids-mattress/",
    title: "Kids Mattress",
    searchslug: "Kids Mattress",
    description:
      "Eclipse International understand the importantance of your little ones to get a good night's sleep. Check out and buy the best kids mattress to help them remain comfortable throughout the night",
  },
  {
    link: "/kids-mattress/baby-cozy/",
    title: "Baby Cozy",
    searchslug: "Baby Cozy Kids Mattress",
    description:
      "Buy Baby cozy Kids mattress which is supported and well ventilated Bonnell springs guarantees an optimal contribution to a good and safe night's rest for the kid. The mattress is Anti-Microbial and ensure proper care for babies.",
  },
  {
    link: "/kids-mattress/baby-care/",
    title: "Baby Care",
    searchslug: "Baby Care Kids Mattress",
    description:
      "Buy baby care mattress at best price that is designed with pure foam that allows kids for easy breathing and circulation of air which giving support to the spine for healthy sleep",
  },
  {
    link: "/memory-foam/",
    title: "Memory Foam",
    searchslug: "Memory Foam",
    description:
      "Pressure relieving, anti-allergen and temperature sensitive for a comfortable, durable sleeping experience. Explore the pure memory foam mattress range from Eclipse.",
  },
  {
    link: "/latex/",
    title: "Latex",
    searchslug: "Latex",
    description:
      "Mattresses that utilise the best-quality natural latex for pressure-relief, high breathability and anti-microbial properties. Best mattresses for asthma sufferers.",
  },
  {
    link: "/spring-mattress/",
    title: "Spring Mattress",
    searchslug: "Spring Mattress",
    description:
      "Explore Eclipse’s high coil count innerspring mattresses for ultimate support. Quality assured with 10 year warranty.",
  },
  {
    link: "/spring-mattress/pocketed-spring/",
    title: "Pocketed Spring",
    searchslug: "Pocketed Spring",
    description:
      "Explore range of luxury mattresses pocketed springs for zero movement transfer and the best firm support- finest quality assured with a 10 year warranty.",
  },
  {
    link: "/spring-mattress/bonnell-spring/",
    title: "Bonnell Spring",
    searchslug: "Bonnell Spring",
    description:
      "Shop the signature range of finest quality Bonnell Spring mattresses- recommended by doctors for unbeatable back support.",
  },

  {
    link: "/spring-mattress/orthobond/",
    title: "Ortho Bond",
    searchslug: "Ortho Bond",
    description:
      "Discover our range of the finest orthobond mattresses with best in class breathable fabric and pressure relieving materials.",
  },
  {
    link: "/exclusive-stores/",
    title: "Exclusive Stores",
    searchslug: "Exclusive Stores",
    description:
      "Shop the Eclipse range of handcrafted mattresses offline. View contact details or schedule a visit to Eclipse’s Exclusive Stores PAN India. ",
  },
  {
    link: "/retail-stores/",
    title: "Retail Stores",
    searchslug: "Retail Stores",
    description:
      "Explore the range of premium handcrafted mattresses from America’s Sleep Specialist at the best retail stores in India. Find an Eclipse retailer near you.",
  },
  {
    link: "/blog/",
    title: "Blog",
    searchslug: "Blogs Articles",
    description:
      "Stay updated with the latest tips and updates about the Sleep, mattresses and Bed Accessories regularly from our experts.",
  },
  {
    link: "/blog/how-sleep-boosts-immunity-system-against-covid-19/",
    title: "How Sleep Boosts Immunity System Against Covid-19",
    searchslug: "How Sleep Boosts Immunity System Against Covid-19",
    description:
      "Explore the relationship between sleep and the body's defences and follow simple steps for a stronger defense against a novel coronavirus infection.",
  },
  {
    link: "/blog/sleep-a-perfect-way-to-regulate-emotions-and-health/",
    title: "Sleep: A Perfect Way To Regulate Emotions And Health",
    searchslug: "Sleep: A Perfect Way To Regulate Emotions And Health",
    description:
      "It's difficult to have a productive day after a sleepless night. Sleepless nights do not only result in unproductive days but much more than that. You can have health issues and bad temperaments too. The ability to make rational decisions also becomes questionable.",
  },
  {
    link: "/blog/good-sleep-makes-better-athletes/",
    title: "Good Sleep Makes Better Athletes",
    searchslug: "Good Sleep Makes Better Athletes",
    description:
      "Explore the relationship between high quality rest and athletic performance in this informative blog from America's Sleep Specialists.",
  },
  {
    link: "/blog/how-can-an-old-mattress-affect-your-sleep/",
    title: "How Can An Old Mattress Affect Your Sleep?",
    searchslug: "How Can An Old Mattress Affect Your Sleep?",
    description:
      "Do you know that mattresses can affect the quality of your sleep? A change of mattress can result in better quality sleep as all the wear and tear of the last mattress will be gone.",
  },
  {
    link: "/blog/all-about-mattresses-for-a-good-night-sleep/",
    title: "All about Mattresses for a Good Night Sleep",
    searchslug: "All about Mattresses for a Good Night Sleep",
    description:
      "Do you know your mattress is an important element when it comes to good night sleep? Bad quality mattress can interrupt your sleep or make you feel exhausted when you wake up in the morning even if you sleep for a night.",
  },
  {
    link: "/blog/new-year-sleep-resolution/",
    title: "New Year Sleep Resolution",
    searchslug: "New Year Sleep Resolution",
    description:
      "Making a new year's resolution is easy but keeping them is what matters. This year make a resolution to improve your sleeping habits by following the simple yet effective steps.",
  },
  {
    link: "/blog/orthopedic-mattresses-for-back-pain/",
    title: "Orthopedic Mattresses for Back Pain?",
    searchslug: "Orthopedic Mattresses for Back Pain?",
    description:
      "Are you suffering from back pain or lower back pain? You might be sleeping on the wrong mattress. Check out what makes the orthopedic mattresses best for the back pain.",
  },
  {
    link: "/blog/the-right-time-to-find-a-new-mattress/",
    title: "The Right Time To Find A New Mattress",
    searchslug: "The Right Time To Find A New Mattress",
    description:
      "Many people experience the effects of a bad/incomplete sleep on next day but many of us fail to recognize what's the reason behind it. Here are a few pointers on which you should really give your attention.",
  },
  {
    link: "/blog/7-habits-of-healthy-sleepers/",
    title: "7 Habits of Healthy Sleepers",
    searchslug: "7 Habits of Healthy Sleepers",
    description:
      "Struggling from sleep disorders make you unhealthy. Transform your sleeping habits and wake up super refreshed and start your day with energetic body and Mind.",
  },
  {
    link: "/blog/the-magic-of-memory-foam/",
    title: "The Magic of Memory Foam",
    searchslug: "The Magic of Memory Foam",
    description:
      "Sleeping on the memory foam mattress has many benefits on both mental and physical health. it improves your sleeping habits and also body posture.",
  },
  {
    link: "/blog/7-ways-to-choose-the-perfect-mattress/",
    title: "7 Ways To Choose The Perfect Mattress",
    searchslug: "7 Ways To Choose The Perfect Mattress",
    description:
      "Without proper guidance, choosing the mattress that suits perfectly is quite difficult. Our guidance to choose the perfect mattress will help you without falling into a trap of salesman.",
  },
  {
    link: "/connect/",
    title: "Connect",
    searchslug: "Connect Contact",
    description:
      "Eclipse International is one of the leading luxury mattress and bed accessories American Brand in India. Contact us for more details in case of further queries.",
  },
  {
    link: "/accessories/pillows/",
    title: "Pillows",
    searchslug: "Pillows",
    description:
      "Explore the range of pillow accessories by Eclipse International and indulge yourself in cozy comfort.",
  },
  {
    link: "/accessories/mattress-protectors/",
    title: "Mattress Protectors",
    searchslug: "Mattress Protectors",
    description:
      "Shop mattress protectors from Eclipse International and keep your mattresses free of spillage, staining, allergens and dust mites.",
  },
  {
    link: "/accessories/eclipse-ultra-soft-duvets/",
    title: "Ultra Soft Duvets",
    searchslug: "Ultra Soft Duvets",
    description:
      "America's Sleep Specialists bring you luxurious and plush yet lighweight duvets developed with the finest fabrics for the ultimate cosy sleep experience.",
  },
  {
    link: "/accessories/bed-bases/",
    title: "Bed Bases",
    searchslug: "Bed Bases",
    description:
      "Excellent craftsmanship and finest materials for a luxurious sleep experience- and upgrade your bed and bedroom today.",
  },
  {
    link: "/accessories/head-boards/",
    title: "Head Boards",
    searchslug: "Head Boards",
    description:
      "Sturdy, durable and premium quality bed bases that uplift indoor design and décor and make everyday a luxurious sleep experience.",
  },
];

export default data;
